export const hcExtra = {
  reservas: {
    buscar: "Rechercher",
    limpiar: "Effacer",
    todas: "Tous",
  },
  nav: {
    volver: "Retour",
  },
  listingDetail: {
    badgeNew: "Nouveau",
  },
  ofertas: {
    precio: "Prix",
  },
  payService: {
    sendRequest: "Envoyer la demande",
  },
  accountCfg: {
    accountEmail: "E-mail du compte",
  },
};
